import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-4 col-sm-6" }
const _hoisted_3 = { class: "card bg-white border-0 rounded-3 mb-4 kanban-for-dark" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_6 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_7 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_8 = { class: "mb-0 fs-14 fw-semibold" }
const _hoisted_9 = { class: "d-flex align-items-center justify-content-between pt-1" }
const _hoisted_10 = { class: "d-flex" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "col-lg-4 col-sm-6" }
const _hoisted_13 = { class: "card bg-white border-0 rounded-3 mb-4 kanban-for-dark" }
const _hoisted_14 = { class: "card-body p-4" }
const _hoisted_15 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_16 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_17 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_18 = { class: "mb-0 fs-14 fw-semibold" }
const _hoisted_19 = { class: "d-flex align-items-center justify-content-between pt-1" }
const _hoisted_20 = { class: "d-flex" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "col-lg-4 col-sm-6" }
const _hoisted_23 = { class: "card bg-white border-0 rounded-3 mb-4 kanban-for-dark" }
const _hoisted_24 = { class: "card-body p-4" }
const _hoisted_25 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_26 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_27 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_28 = { class: "mb-0 fs-14 fw-semibold" }
const _hoisted_29 = { class: "d-flex align-items-center justify-content-between pt-1" }
const _hoisted_30 = { class: "d-flex" }
const _hoisted_31 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "mb-0 fs-16 fw-medium" }, "To Do", -1)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, _cache[0] || (_cache[0] = [
              _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-20 fw-bold text-body hover\"> more_horiz </i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
            ]))), [
              [
                _directive_b_tooltip,
                'More_Option',
                void 0,
                {
                  hover: true,
                  top: true
                }
              ]
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toDo, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "rounded-3 mb-4",
              style: _normalizeStyle([{
              background: item.bgClass,
            }, {"padding":"20px"}])
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h4", _hoisted_8, _toDisplayString(item.title), 1),
                _cache[2] || (_cache[2] = _createElementVNode("button", { class: "material-symbols-outlined fs-20 text-body hover border-0 p-0 bg-transparent" }, " edit ", -1))
              ]),
              _createElementVNode("p", null, _toDisplayString(item.description), 1),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.users, (user) => {
                    return (_openBlock(), _createBlock(_component_RouterLink, {
                      to: "/my-profile",
                      key: user.id,
                      class: _normalizeClass(user.class)
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: user.image,
                          class: "wh-34 rounded-circle border border-2 border-color-white",
                          alt: "user"
                        }, null, 8, _hoisted_11)
                      ]),
                      _: 2
                    }, 1032, ["class"]))
                  }), 128))
                ]),
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-primary" }, "5 days left", -1))
              ])
            ], 4))
          }), 128)),
          _cache[4] || (_cache[4] = _createElementVNode("button", {
            class: "btn btn-outline-primary py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3 hover-bg",
            "data-bs-toggle": "offcanvas",
            "data-bs-target": "#addNewCardModal",
            "aria-controls": "addNewCardModal"
          }, [
            _createElementVNode("span", { class: "py-sm-1 d-block" }, [
              _createElementVNode("i", { class: "ri-add-line d-none d-sm-inline-block me-1" }),
              _createElementVNode("span", null, "Add New Card")
            ])
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "mb-0 fs-16 fw-medium" }, "Doing", -1)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_16, _cache[5] || (_cache[5] = [
              _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-20 fw-bold text-body hover\"> more_horiz </i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
            ]))), [
              [
                _directive_b_tooltip,
                'More_Option',
                void 0,
                {
                  hover: true,
                  top: true
                }
              ]
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.doing, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "rounded-3 mb-4",
              style: _normalizeStyle([{
              background: item.bgClass,
            }, {"padding":"20px"}])
            }, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("h4", _hoisted_18, _toDisplayString(item.title), 1),
                _cache[7] || (_cache[7] = _createElementVNode("button", { class: "material-symbols-outlined fs-20 text-body hover border-0 p-0 bg-transparent" }, " edit ", -1))
              ]),
              _createElementVNode("p", null, _toDisplayString(item.description), 1),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.users, (user) => {
                    return (_openBlock(), _createBlock(_component_RouterLink, {
                      to: "/my-profile",
                      key: user.id,
                      class: _normalizeClass(user.class)
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: user.image,
                          class: "wh-34 rounded-circle border border-2 border-color-white",
                          alt: "user"
                        }, null, 8, _hoisted_21)
                      ]),
                      _: 2
                    }, 1032, ["class"]))
                  }), 128))
                ]),
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-primary" }, "3 days left", -1))
              ])
            ], 4))
          }), 128)),
          _cache[9] || (_cache[9] = _createElementVNode("button", {
            class: "btn btn-outline-primary py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3 hover-bg",
            "data-bs-toggle": "offcanvas",
            "data-bs-target": "#addNewCardModal",
            "aria-controls": "addNewCardModal"
          }, [
            _createElementVNode("span", { class: "py-sm-1 d-block" }, [
              _createElementVNode("i", { class: "ri-add-line d-none d-sm-inline-block me-1" }),
              _createElementVNode("span", null, "Add New Card")
            ])
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _cache[11] || (_cache[11] = _createElementVNode("h4", { class: "mb-0 fs-16 fw-medium" }, "Done", -1)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_26, _cache[10] || (_cache[10] = [
              _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-20 fw-bold text-body hover\"> more_horiz </i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
            ]))), [
              [
                _directive_b_tooltip,
                'More_Option',
                void 0,
                {
                  hover: true,
                  top: true
                }
              ]
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.done, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "rounded-3 mb-4",
              style: _normalizeStyle([{
              background: item.bgClass,
            }, {"padding":"20px"}])
            }, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("h4", _hoisted_28, _toDisplayString(item.title), 1),
                _cache[12] || (_cache[12] = _createElementVNode("button", { class: "material-symbols-outlined fs-20 text-body hover border-0 p-0 bg-transparent" }, " edit ", -1))
              ]),
              _createElementVNode("p", null, _toDisplayString(item.description), 1),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.users, (user) => {
                    return (_openBlock(), _createBlock(_component_RouterLink, {
                      to: "/my-profile",
                      key: user.id,
                      class: _normalizeClass(user.class)
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: user.image,
                          class: "wh-34 rounded-circle border border-2 border-color-white",
                          alt: "user"
                        }, null, 8, _hoisted_31)
                      ]),
                      _: 2
                    }, 1032, ["class"]))
                  }), 128))
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "text-primary" }, "3 days left", -1))
              ])
            ], 4))
          }), 128)),
          _cache[14] || (_cache[14] = _createElementVNode("button", {
            class: "btn btn-outline-primary py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3 hover-bg",
            "data-bs-toggle": "offcanvas",
            "data-bs-target": "#addNewCardModal",
            "aria-controls": "addNewCardModal"
          }, [
            _createElementVNode("span", { class: "py-sm-1 d-block" }, [
              _createElementVNode("i", { class: "ri-add-line d-none d-sm-inline-block me-1" }),
              _createElementVNode("span", null, "Add New Card")
            ])
          ], -1))
        ])
      ])
    ])
  ]))
}